import type { EChartsCoreOption } from 'echarts/core';

import { CHART_HEADINGS } from '../constants';
import { ChartBlock } from './MonitoringChart';

type MonitoringAlertsSectionProps = {
  severityOption: EChartsCoreOption | null;
  controlOption: EChartsCoreOption | null;
  severityLoading: boolean;
  controlLoading: boolean;
  chartHeight: number;
};

const MonitoringAlertsSection = ({
  severityOption,
  controlOption,
  severityLoading,
  controlLoading,
  chartHeight
}: MonitoringAlertsSectionProps) => (
  <section className="realtime-monitoring-tab__section realtime-monitoring-tab__section--alerts">
    <h2 className="realtime-monitoring-tab__section-title">Alerts</h2>
    <div className="realtime-monitoring-tab__chart-grid realtime-monitoring-tab__chart-grid--alerts">
      <ChartBlock
        title={CHART_HEADINGS.alertsSeverity}
        option={severityOption}
        loading={severityLoading}
        modern
        chartHeight={chartHeight}
      />
      <ChartBlock
        title={CHART_HEADINGS.alertsControl}
        option={controlOption}
        loading={controlLoading}
        modern
        chartHeight={chartHeight}
      />
    </div>
  </section>
);

export default MonitoringAlertsSection;
